export const Lazyloading = () => {
    (function(w, d) {
        const b = d.getElementsByTagName('body')[0];
        const s = d.createElement('script');
        const v = !('IntersectionObserver' in w) ? '8.15.0' : '10.15.0';
        s.async = true;
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/vanilla-lazyload/' + v + '/lazyload.min.js';
        w.lazyLoadOptions = {
            /* eslint-disable camelcase */
            elements_selector: '.lazy',
            to_webp: true
            /* eslint-enable camelcase */
        };
        b.appendChild(s);
    })(window, document);
};

export default Lazyloading;
